import React, { useState } from "react";
import DataTable from "../../components/table/data-table";
import { InviteModal, SuccessModal } from "../../components/modal";
import { useNavigate } from "react-router-dom";
import PageIntroNav from "../../components/navigation/PageIntroNav";

const CashTypes = () => {
  const [opencashtypeModal, setOpencashtypeModal] = useState(false);
  const [opensucessModal, setOpenSucessModal] = useState(false);

  const openModal = () => {
    setOpencashtypeModal(true);
  };

  const navigate = useNavigate();

  const createHandleSuccess = (ev) => {
    ev.preventDefault();
    setOpencashtypeModal(false);
    setOpenSucessModal(true);
  };
  const flows = [
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
    { level: "Team Lead", approver: "Managing Director, Team Lead" },
  ];

  const headings = ["Level", "Approvers", "Actions"];
  const columns = ["level", "approver"];
  return (
    <div>
      <PageIntroNav
        breadcrumbs={[
          { label: "Company Settings", path: "/company-settings" },
          { label: "Cash Types" },
        ]}
        title="Leave Flows"
        fallbackPath="/company-settings"
        backLabel="Back to Company Settings"
        actions={(
          <button
            onClick={openModal}
            className="bg-[#1234CD] px-6 py-2 rounded-xl text-white"
          >
            Add new
          </button>
        )}
      />

      <DataTable
        title=""
        headings={headings}
        columns={columns}
        data={flows}
        onView={() => navigate("/company-settings/leave-flow-details")}
      />

      <InviteModal
        isOpen={opencashtypeModal}
        onClose={() => setOpencashtypeModal(false)}
      >
        <div className="my-8">
          <div>
            <p className=" text-2xl font-semibold text-black font-Outfit">
              Approval Flow
            </p>
          </div>
          <form
            className="my-12"
            onSubmit={createHandleSuccess}
          >
            <div>
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-black leading-[18.9px] font-satosh"
              >
                Level
              </label>
              <input
                type="text"
                id="text"
                placeholder="Title"
                // value={inviteEmail}
                // onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 text-center mb-2  rounded-xl focus:outline-[#1234CD] border-2 border-[#F3F5F5] py-[16px]"
              />
            </div>

            <div>
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-black leading-[18.9px] font-satosh"
              >
                Choose Approver
              </label>
              <input
                type="text"
                id="text"
                placeholder="Title"
                // value={inviteEmail}
                // onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 text-center mb-2 rounded-xl focus:outline-[#1234CD] border-2 border-[#F3F5F5] py-[16px]"
              />
            </div>

            <div className=" flex mt-40 justify-center">
              <button
                type="submit"
                className="font-[700] font-satoshi  leading-[21.6px] w-40 rounded-xl text-white py-[16px] bg-[#1234CD]  h-[40px]text-[16px] "
              >
                <span>Create</span>
              </button>
            </div>
          </form>
        </div>
      </InviteModal>

      <SuccessModal
        isOpen={opensucessModal}
        onClose={() => setOpenSucessModal(false)}
      />
    </div>
  );
};

export default CashTypes;
